module.exports = __webpack_public_path__ + "static/media/icon-search-disabled.bde5644f.svg";